import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import FloatingDemoWindow from './FloatingDemoWindow';

const HeroSection = ({ onPrimaryClick, onSecondaryClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-brand-tagline">
            AiStonks — Your AI Co-Pilot for trading & investing
          </div>
          <h1 className="hero-headline">
            Investing, simplified.
          </h1>
          <p className="hero-subheadline">
            AiStonks turns plain English into smart investment actions — no clutter, no confusion.
          </p>
          
          <div className="hero-cta-group">
            <Button 
              onClick={onPrimaryClick}
              className="btn-primary"
            >
              Join the Early Access Waitlist
              <ArrowRight className="w-5 h-5" />
            </Button>
            <Button 
              onClick={onSecondaryClick}
              className="btn-secondary"
              variant="secondary"
            >
              See How It Works
            </Button>
          </div>

          <p className="hero-caption">
            From words to trades — effortlessly.
          </p>
        </div>
        
        {/* Mobile demo interface - only in hero */}
        <div className="hero-demo-mobile">
          <FloatingDemoWindow />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
